import React from 'react';
import { Col, Container, Row } from 'react-bootstrap';

function VisionMission() {
  return (
    <Container className="py-5 text-light">
      <Row className="justify-content-center">
        <Col lg={8}>
          <h1 className="h2 fw-bold mb-4">Vision & Mission</h1>

          <section className="mb-5">
            <h2 className="h4 section-heading mb-3">Vision</h2>
            <p className="text-white-50 mb-0">A world where every machine identity is known, governed, and secured — with the same rigor we apply to human identities, at the speed machines actually operate.</p>
          </section>

          <section className="mb-5">
            <h2 className="h4 section-heading mb-3">Mission</h2>
            <p className="text-white-50 mb-0">Build the identity broker for the agentic era — the layer enterprises need to govern non-human identities at scale. Provision time-bound credentials via a federated broker, surface every identity relationship and usage pattern through a live graph, detect behavioral anomalies before they become breaches, and enforce lifecycle policy continuously — across every environment, cloud provider, and orchestration layer your machines touch.</p>
          </section>

          <section className="mb-5">
            <h2 className="h4 section-heading mb-3">The Opportunity</h2>
            <p className="text-white-50 mb-3">Machine identities — service accounts, AI agents, workload credentials, CI/CD runners, API keys — now vastly outnumber human identities in enterprise environments. The tooling built for human IAM is fundamentally mismatched to this problem: it assumes infrequent logins, human-readable access patterns, and manageable scale. None of those assumptions hold for machines.</p>
            <p className="text-white-50 mb-0">PAM vendors vault secrets. Cloud IAM manages access policies. Neither provisions machine identities at scale, maps their relationships, detects behavioral anomalies, or enforces lifecycle governance. That gap is what Arkodomo closes.</p>
          </section>

          <section className="mb-5">
            <h2 className="h5 section-heading mb-3">Operating Principles</h2>
            <ul className="text-white-50 mb-0" style={{ lineHeight: 2 }}>
              <li>Incremental adoption — connect to existing infrastructure, don't replace it.</li>
              <li>Customer-hosted, customer-controlled — no inbound exposure, encrypted connections, no data leaves your perimeter.</li>
              <li>Ephemeral by default — credential federation where possible, automated rotation enforcement everywhere else.</li>
              <li>Not in the critical path — credentials are issued at provisioning time; workloads call APIs directly.</li>
              <li>Visibility before enforcement — the identity graph must come before the policy engine.</li>
            </ul>
          </section>

          <section>
            <p className="text-white-50 mb-0">Arkodomo is built on <strong>Arkodomo Fabric</strong> — the policy, issuance, and audit layer that provides a single abstraction across heterogeneous environments.</p>
          </section>
        </Col>
      </Row>
    </Container>
  );
}

export default VisionMission;
